import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store/Module/UserGuidance
 * @project ChalkySticks SDK Vue2.0 Components
 */
const mutations = {
	/**
	 * @param State state
	 * @param any payload
	 * @return void
	 */
	example(state: typeof State, payload: any): void {
		state.foo = 'boo';
	},

	/**
	 * Set the coach marks that have been seen
	 *
	 * @param State state
	 * @param string[] coachMarksSeen
	 * @return void
	 */
	setCoachMarksSeen(state: typeof State, coachMarksSeen: string[]): void {
		state.coachMarksSeen = coachMarksSeen;
	},

	/**
	 * Legacy alias for setCoachMarksSeen (for backwards compatibility)
	 *
	 * @param State state
	 * @param string[] tooltipsSeen
	 * @return void
	 */
	setTooltipsSeen(state: typeof State, tooltipsSeen: string[]): void {
		state.coachMarksSeen = tooltipsSeen;
	},
};

export default mutations;
